import { styled } from '@mui/material/styles';
import { useKeycloak } from '@react-keycloak/web';
import FusePageSimple from '../../../../@fuse/core/FusePageSimple';
import EntidadDetalle from './components/entidadDetalle';
import Error404Page from "../../404/Error404Page";

const Root = styled(FusePageSimple)(({ theme }) => ({
  '& .FusePageSimple-header': {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  },
  '& .FusePageSimple-toolbar': {},
  '& .FusePageSimple-content': {},
  '& .FusePageSimple-sidebarHeader': {},
  '& .FusePageSimple-sidebarContent': {},
}));

function Entidad(props) {
  const { keycloak } = useKeycloak();
  const roleKeycloak = keycloak?.realmAccess?.roles[0];

  return (
    <>
      {['NOC', 'Administrador'].includes(roleKeycloak) ? (
        <FusePageSimple
          content={
            <div className="w-full p-24">
              <EntidadDetalle />
            </div>
          }
        />
      ): (
        <Error404Page />
      )}
    </>
  );
}

export default Entidad;
